module.exports = __webpack_public_path__ + "static/media/add-plus.68b192ae.jpg";